import { createReducer, on } from '@ngrx/store';
import * as BizActions from './biz-brand.action';
import { BizBrand } from '../../models/biz-brand';

export interface BizBrandState {
  bizBrand: BizBrand[] | any;
  loading: boolean;
  error: any;
}

export const initialState: BizBrandState = {
  bizBrand: [],
  loading: false,
  error: null,
};

export const bizBrandReducer = createReducer(
  initialState,
  on(BizActions.loadBizBrand, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(BizActions.loadBizBrandSuccess, (state, { bizBrand }) => ({
    ...state,
    bizBrand,
    loading: false,
  })),
  on(BizActions.loadBizBrandFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);